import React, { memo } from 'react'

import styled from '@emotion/styled'

import { Cross } from '@surglogs-app/icons'

import { Button, ButtonProps } from './Button'

const StyledButton = styled(Button)`
  & svg {
    color: ${({ theme, disabled }) =>
      disabled ? theme.ui.colors['navy.50'] : theme.ui.colors['red.100']};
  }

  &:hover {
    background-color: ${({ theme }) => theme.ui.colors['red.100']};
    border-color: ${({ theme }) => theme.ui.colors['red.100']};
    color: ${({ theme }) => theme.ui.colors['white.100']};

    & svg {
      color: ${({ theme, disabled }) =>
        disabled ? theme.ui.colors['navy.50'] : theme.ui.colors['white.100']};
    }
  }
`

export const RemoveButton = memo(
  ({
    variant = 'secondary',
    icon = Cross,
    ...rest
  }: Omit<ButtonProps, 'ref'>) => (
    <StyledButton {...{ icon, variant, ...rest }} />
  ),
)
